$.validator.addMethod('zipcode', (value) => {
	let regex = /^([0-9]{4} ?[a-z]{2})$/gi;
	let result = value.match(regex);
	return result != null;
}, '<i class="fa fa-times"></i> Vul een geldige postcode in!');

class Form {
	constructor(config) {
		this.config = Object.assign({
			scope: 'form'
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.$scope.find('.form-group-submit input').removeClass('btn').addClass('theme-btn');
		this.addZipcodeRule();
	}

	addZipcodeRule() {
		if(!(this.$scope.hasClass('no-validate'))) {
			let $input = this.$scope.find('[name*=postcode]');
			$input.on('change', (e) => {
				let $input = $(e.currentTarget);
				$input.valid();
				$input.rules('add', 'zipcode');
			});
		}
	}
}

export default new Form;